// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Css = require("bs-css-emotion/src/Css.bs.js");
var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Js_array = require("rescript/lib/js/js_array.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Icon__Jsx3 = require("../../atoms/Icon/Icon__Jsx3.bs.js");
var Responsive = require("../../helpers/Responsive.bs.js");
var Text__Jsx3 = require("../../helpers/Text__Jsx3.bs.js");
var View__Jsx3 = require("../../helpers/View__Jsx3.bs.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Avatar__Jsx3 = require("../../atoms/Avatar/Avatar__Jsx3.bs.js");
var Theme__Color = require("../../../../reason/common/Theme/Theme__Color.bs.js");
var JsxPPXReactSupport = require("rescript/lib/js/jsxPPXReactSupport.js");
var Theme__Color__Vars = require("../../../../reason/common/Theme/Theme__Color__Vars.bs.js");
var Colors = require("uikit/styles/colors");

var DisplayParticipant = {};

function ConversationCard__Jsx3$Badge(props) {
  return React.createElement("div", {
              className: Curry._1(Css.style, {
                    hd: Css.alignContent("center"),
                    tl: {
                      hd: Css.alignItems("center"),
                      tl: {
                        hd: Css.backgroundColor(Theme__Color.tussock),
                        tl: {
                          hd: Css.borderRadius({
                                NAME: "percent",
                                VAL: 50
                              }),
                          tl: {
                            hd: Css.color(Theme__Color.white),
                            tl: {
                              hd: Css.fontSize({
                                    NAME: "px",
                                    VAL: 13
                                  }),
                              tl: {
                                hd: Css.fontWeight("bold"),
                                tl: {
                                  hd: Css.height({
                                        NAME: "px",
                                        VAL: 19
                                      }),
                                  tl: {
                                    hd: Css.width({
                                          NAME: "px",
                                          VAL: 19
                                        }),
                                    tl: {
                                      hd: Css.lineHeight({
                                            NAME: "px",
                                            VAL: 19
                                          }),
                                      tl: {
                                        hd: Css.justifyContent("center"),
                                        tl: {
                                          hd: Css.textAlign("center"),
                                          tl: {
                                            hd: Css.position("absolute"),
                                            tl: {
                                              hd: Css.top({
                                                    NAME: "px",
                                                    VAL: 8
                                                  }),
                                              tl: {
                                                hd: Css.right({
                                                      NAME: "px",
                                                      VAL: 8
                                                    }),
                                                tl: /* [] */0
                                              }
                                            }
                                          }
                                        }
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  })
            }, props.children);
}

var Badge = {
  make: ConversationCard__Jsx3$Badge
};

function ConversationCard__Jsx3$DetailsWrapper(props) {
  var removed = props.removed;
  var removed$1 = removed !== undefined ? removed : false;
  var iconComponent = function (x) {
    if (x.NAME === "image") {
      return React.createElement("img", {
                  className: Curry._1(Css.style, {
                        hd: Css.flexShrink(0),
                        tl: /* [] */0
                      }),
                  height: "35px",
                  src: x.VAL,
                  width: "35px"
                });
    }
    var name = x.VAL;
    return React.createElement(View__Jsx3.make, {
                height: {
                  NAME: "px",
                  VAL: 32
                },
                alignItems: "center",
                children: Caml_option.some(removed$1 ? React.createElement(Icon__Jsx3.make, {
                            icon: name,
                            size: 32,
                            color: Theme__Color__Vars.silverSand
                          }) : React.createElement(Icon__Jsx3.make, {
                            icon: name,
                            size: 32,
                            color: Theme__Color__Vars.astral
                          }))
              });
  };
  return React.createElement(View__Jsx3.make, {
              mt: {
                NAME: "px",
                VAL: 10
              },
              alignItems: "center",
              flexDirection: "row",
              flexGrow: 1,
              children: Caml_option.some(null)
            }, iconComponent(props.icon), React.createElement(View__Jsx3.make, {
                  ml: {
                    NAME: "px",
                    VAL: 10
                  },
                  children: Caml_option.some(props.children)
                }));
}

var DetailsWrapper = {
  make: ConversationCard__Jsx3$DetailsWrapper
};

function ConversationCard__Jsx3$DetailsFirstLine(props) {
  return React.createElement(Text__Jsx3.make, {
              as_: "div",
              fontSize: {
                NAME: "px",
                VAL: 14
              },
              lineHeight: {
                NAME: "px",
                VAL: 17
              },
              color: Colors.doveGray,
              lineClamp: 1,
              children: props.value
            });
}

var DetailsFirstLine = {
  make: ConversationCard__Jsx3$DetailsFirstLine
};

function ConversationCard__Jsx3$DetailsSecondLine(props) {
  var lineClamp = props.lineClamp;
  var lineClamp$1 = lineClamp !== undefined ? lineClamp : 1;
  return React.createElement(Text__Jsx3.make, {
              as_: "div",
              fontSize: {
                NAME: "px",
                VAL: 13
              },
              lineHeight: {
                NAME: "px",
                VAL: 15
              },
              color: Colors.gray,
              lineClamp: lineClamp$1,
              children: props.value
            });
}

var DetailsSecondLine = {
  make: ConversationCard__Jsx3$DetailsSecondLine
};

function ConversationCard__Jsx3$DetailsPrice(props) {
  return React.createElement(Text__Jsx3.make, {
              as_: "div",
              fontSize: {
                NAME: "px",
                VAL: 14
              },
              lineHeight: {
                NAME: "num",
                VAL: 1.25
              },
              color: Colors.tussock,
              lineClamp: 1,
              children: props.value
            });
}

var DetailsPrice = {
  make: ConversationCard__Jsx3$DetailsPrice
};

var style = Curry._1(Css.style, {
      hd: Css.width({
            NAME: "px",
            VAL: 3
          }),
      tl: {
        hd: Css.position("absolute"),
        tl: {
          hd: Css.top({
                NAME: "px",
                VAL: 0
              }),
          tl: {
            hd: Css.left({
                  NAME: "px",
                  VAL: 0
                }),
            tl: {
              hd: Css.height({
                    NAME: "percent",
                    VAL: 100
                  }),
              tl: {
                hd: Css.backgroundColor(Theme__Color.tussock),
                tl: /* [] */0
              }
            }
          }
        }
      }
    });

function ConversationCard__Jsx3$SelectedBorder(props) {
  return React.createElement("div", {
              className: style
            });
}

var SelectedBorder = {
  style: style,
  make: ConversationCard__Jsx3$SelectedBorder
};

var cardHeightInPixels = {
  NAME: "px",
  VAL: 98
};

function ConversationCard__Jsx3(props) {
  var selected = props.selected;
  var unreadCount = props.unreadCount;
  var people = props.people;
  var selected$1 = selected !== undefined ? selected : false;
  var tmp;
  if (people.length !== 1) {
    tmp = React.createElement(Avatar__Jsx3.Group.make, {
          children: Belt_Array.map(Belt_Array.slice(people, 0, 2), (function (param) {
                  var avatarURL = param.avatarURL;
                  var longLabel = param.longLabel;
                  return JsxPPXReactSupport.createElementWithKey(avatarURL + longLabel, Avatar__Jsx3.make, {
                              src: avatarURL,
                              name: longLabel
                            });
                }))
        });
  } else {
    var match = people[0];
    tmp = React.createElement(Avatar__Jsx3.make, {
          src: match.avatarURL,
          name: match.longLabel
        });
  }
  return React.createElement(View__Jsx3.make, {
              p: {
                NAME: "px",
                VAL: 10
              },
              height: cardHeightInPixels,
              alignItems: "flexStart",
              flexDirection: "row",
              flexGrow: 0,
              position: "relative",
              borderStyle: "solid",
              borderWidth: "0 0 1px 0",
              borderColor: Colors.alto,
              backgroundColor: selected$1 ? Theme__Color.alabaster : Theme__Color.white,
              children: Caml_option.some(null)
            }, selected$1 ? React.createElement(ConversationCard__Jsx3$SelectedBorder, {}) : null, tmp, React.createElement(View__Jsx3.make, {
                  ml: {
                    NAME: "px",
                    VAL: 10
                  },
                  flexDirection: "column",
                  flexGrow: 1,
                  flexBasis: {
                    NAME: "percent",
                    VAL: 0
                  },
                  overflow: "hidden",
                  children: Caml_option.some(null)
                }, React.createElement(View__Jsx3.make, {
                      justifyContent: "spaceBetween",
                      children: Caml_option.some(null)
                    }, React.createElement(Text__Jsx3.make, {
                          fontSize: {
                            NAME: "px",
                            VAL: 14
                          },
                          fontWeight: "bold",
                          lineClamp: 1,
                          children: people.length !== 1 ? Js_array.joinWith(", ", Belt_Array.map(people, (function (param) {
                                        return param.shortLabel;
                                      }))) : people[0].longLabel
                        }), unreadCount === 0 ? null : React.createElement(ConversationCard__Jsx3$Badge, {
                            children: String(unreadCount)
                          })), React.createElement(View__Jsx3.make, {
                      alignItems: "center",
                      justifyContent: "spaceBetween",
                      children: Caml_option.some(null)
                    }, React.createElement(Text__Jsx3.make, {
                          as_: "div",
                          fontSize: {
                            NAME: "px",
                            VAL: 14
                          },
                          lineHeight: {
                            NAME: "px",
                            VAL: 17
                          },
                          color: Colors.doveGray,
                          lineClamp: 1,
                          children: props.summary
                        }), React.createElement(View__Jsx3.make, {
                          ml: {
                            NAME: "px",
                            VAL: 5
                          },
                          children: Caml_option.some(React.createElement(Text__Jsx3.make, {
                                    fontSize: {
                                      NAME: "px",
                                      VAL: 13
                                    },
                                    color: Colors.gray,
                                    children: props.timestamp
                                  }))
                        })), props.children));
}

var View;

var Heading;

var $$Text;

var Avatar;

var Icon;

var responsive = Responsive.make;

var cardHeight = 98.0;

var make = ConversationCard__Jsx3;

exports.View = View;
exports.Heading = Heading;
exports.$$Text = $$Text;
exports.Avatar = Avatar;
exports.Icon = Icon;
exports.responsive = responsive;
exports.DisplayParticipant = DisplayParticipant;
exports.Badge = Badge;
exports.DetailsWrapper = DetailsWrapper;
exports.DetailsFirstLine = DetailsFirstLine;
exports.DetailsSecondLine = DetailsSecondLine;
exports.DetailsPrice = DetailsPrice;
exports.SelectedBorder = SelectedBorder;
exports.cardHeight = cardHeight;
exports.cardHeightInPixels = cardHeightInPixels;
exports.make = make;
/* style Not a pure module */
